/** Vertical physics (02 §3 / 12 §8.7; live since Sprint 10 for the jump-dodge, spec §1.3).
 *  A no-op for anything grounded on a pad. The step is exact constant-acceleration
 *  kinematics (position from the mean velocity over the tick), not semi-implicit
 *  Euler, so the discrete trajectory matches the design numbers: JUMP_V0 7.6 at
 *  GRAVITY 20 reaches 1.444 m at tick 23 and is back at the floor on tick 46. */
import { GRAVITY, VOID_KILL_Y } from './constants.js'
import type { Vec3 } from './types.js'

export interface Falling { pos: Vec3; vel: Vec3; grounded: boolean }

/** Returns true if the entity fell below VOID_KILL_Y this step. */
export function applyGravity(e: Falling, dt: number): boolean {
  if (e.grounded) return false
  e.pos.y += (e.vel.y - 0.5 * GRAVITY * dt) * dt
  e.vel.y -= GRAVITY * dt
  return e.pos.y < VOID_KILL_Y
}
